import { j as s } from "./jsx-runtime.DGlMoOmv.js";
import * as i from "react";
import { c as G, u as H, a as P } from "./index.stoqs9MZ.js";
import { u as O, c as K } from "./index.B4ZV02se.js";
import { D as Q } from "./index.DNGle7LJ.js";
import { h as U, R as V, u as W, F as Z } from "./Combination.r_wXKfB6.js";
import { u as q } from "./index.BUG7NYeV.js";
import { c as j, A as B, R as J, a as b, C as X } from "./index.C27qk3BS.js";
import { P as Y } from "./index.RcubEhGW.js";
import { P as _ } from "./index.TrmYLGk6.js";
import { P as N } from "./index.DMLWxr4u.js";
import { u as ee } from "./use-media-query.CzJ6WnFm.js";
import { c as A } from "./index.CxSWpsOB.js";
import { c as oe, a as te, b as re, j as ne } from "./Drawer.DJSM1vCc.js";
var h = "Popover", [E, ke] = G(h, [
  j
]), m = j(), [se, l] = E(h), y = (e) => {
  const {
    __scopePopover: t,
    children: o,
    open: n,
    defaultOpen: r,
    onOpenChange: a,
    modal: c = !1
  } = e, p = m(t), f = i.useRef(null), [v, x] = i.useState(!1), [C, u] = H({
    prop: n,
    defaultProp: r ?? !1,
    onChange: a,
    caller: h
  });
  return /* @__PURE__ */ s.jsx(J, { ...p, children: /* @__PURE__ */ s.jsx(
    se,
    {
      scope: t,
      contentId: q(),
      triggerRef: f,
      open: C,
      onOpenChange: u,
      onOpenToggle: i.useCallback(() => u((w) => !w), [u]),
      hasCustomAnchor: v,
      onCustomAnchorAdd: i.useCallback(() => x(!0), []),
      onCustomAnchorRemove: i.useCallback(() => x(!1), []),
      modal: c,
      children: o
    }
  ) });
};
y.displayName = h;
var M = "PopoverAnchor", ae = i.forwardRef(
  (e, t) => {
    const { __scopePopover: o, ...n } = e, r = l(M, o), a = m(o), { onCustomAnchorAdd: c, onCustomAnchorRemove: p } = r;
    return i.useEffect(() => (c(), () => p()), [c, p]), /* @__PURE__ */ s.jsx(b, { ...a, ...n, ref: t });
  }
);
ae.displayName = M;
var D = "PopoverTrigger", F = i.forwardRef(
  (e, t) => {
    const { __scopePopover: o, ...n } = e, r = l(D, o), a = m(o), c = O(t, r.triggerRef), p = /* @__PURE__ */ s.jsx(
      N.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": r.open,
        "aria-controls": r.contentId,
        "data-state": z(r.open),
        ...n,
        ref: c,
        onClick: P(e.onClick, r.onOpenToggle)
      }
    );
    return r.hasCustomAnchor ? p : /* @__PURE__ */ s.jsx(b, { asChild: !0, ...a, children: p });
  }
);
F.displayName = D;
var R = "PopoverPortal", [ie, ce] = E(R, {
  forceMount: void 0
}), S = (e) => {
  const { __scopePopover: t, forceMount: o, children: n, container: r } = e, a = l(R, t);
  return /* @__PURE__ */ s.jsx(ie, { scope: t, forceMount: o, children: /* @__PURE__ */ s.jsx(_, { present: o || a.open, children: /* @__PURE__ */ s.jsx(Y, { asChild: !0, container: r, children: n }) }) });
};
S.displayName = R;
var d = "PopoverContent", T = i.forwardRef(
  (e, t) => {
    const o = ce(d, e.__scopePopover), { forceMount: n = o.forceMount, ...r } = e, a = l(d, e.__scopePopover);
    return /* @__PURE__ */ s.jsx(_, { present: n || a.open, children: a.modal ? /* @__PURE__ */ s.jsx(le, { ...r, ref: t }) : /* @__PURE__ */ s.jsx(ue, { ...r, ref: t }) });
  }
);
T.displayName = d;
var pe = K("PopoverContent.RemoveScroll"), le = i.forwardRef(
  (e, t) => {
    const o = l(d, e.__scopePopover), n = i.useRef(null), r = O(t, n), a = i.useRef(!1);
    return i.useEffect(() => {
      const c = n.current;
      if (c) return U(c);
    }, []), /* @__PURE__ */ s.jsx(V, { as: pe, allowPinchZoom: !0, children: /* @__PURE__ */ s.jsx(
      k,
      {
        ...e,
        ref: r,
        trapFocus: o.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: P(e.onCloseAutoFocus, (c) => {
          c.preventDefault(), a.current || o.triggerRef.current?.focus();
        }),
        onPointerDownOutside: P(
          e.onPointerDownOutside,
          (c) => {
            const p = c.detail.originalEvent, f = p.button === 0 && p.ctrlKey === !0, v = p.button === 2 || f;
            a.current = v;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: P(
          e.onFocusOutside,
          (c) => c.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), ue = i.forwardRef(
  (e, t) => {
    const o = l(d, e.__scopePopover), n = i.useRef(!1), r = i.useRef(!1);
    return /* @__PURE__ */ s.jsx(
      k,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          e.onCloseAutoFocus?.(a), a.defaultPrevented || (n.current || o.triggerRef.current?.focus(), a.preventDefault()), n.current = !1, r.current = !1;
        },
        onInteractOutside: (a) => {
          e.onInteractOutside?.(a), a.defaultPrevented || (n.current = !0, a.detail.originalEvent.type === "pointerdown" && (r.current = !0));
          const c = a.target;
          o.triggerRef.current?.contains(c) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && r.current && a.preventDefault();
        }
      }
    );
  }
), k = i.forwardRef(
  (e, t) => {
    const {
      __scopePopover: o,
      trapFocus: n,
      onOpenAutoFocus: r,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: c,
      onEscapeKeyDown: p,
      onPointerDownOutside: f,
      onFocusOutside: v,
      onInteractOutside: x,
      ...C
    } = e, u = l(d, o), w = m(o);
    return W(), /* @__PURE__ */ s.jsx(
      Z,
      {
        asChild: !0,
        loop: !0,
        trapped: n,
        onMountAutoFocus: r,
        onUnmountAutoFocus: a,
        children: /* @__PURE__ */ s.jsx(
          Q,
          {
            asChild: !0,
            disableOutsidePointerEvents: c,
            onInteractOutside: x,
            onEscapeKeyDown: p,
            onPointerDownOutside: f,
            onFocusOutside: v,
            onDismiss: () => u.onOpenChange(!1),
            children: /* @__PURE__ */ s.jsx(
              X,
              {
                "data-state": z(u.open),
                role: "dialog",
                id: u.contentId,
                ...w,
                ...C,
                ref: t,
                style: {
                  ...C.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), I = "PopoverClose", $ = i.forwardRef(
  (e, t) => {
    const { __scopePopover: o, ...n } = e, r = l(I, o);
    return /* @__PURE__ */ s.jsx(
      N.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: P(e.onClick, () => r.onOpenChange(!1))
      }
    );
  }
);
$.displayName = I;
var de = "PopoverArrow", L = i.forwardRef(
  (e, t) => {
    const { __scopePopover: o, ...n } = e, r = m(o);
    return /* @__PURE__ */ s.jsx(B, { ...r, ...n, ref: t });
  }
);
L.displayName = de;
function z(e) {
  return e ? "open" : "closed";
}
var fe = y, ve = F, Pe = S, me = T, ge = L;
const g = i.createContext({
  isMobile: !1,
  isResponsive: !1
}), xe = ({
  isResponsive: e = !1,
  ...t
}) => {
  const o = ee("(max-width: 576px)", {
    isActive: e
  }), [n, r] = i.useState(!1);
  return /* @__PURE__ */ s.jsx(g.Provider, { value: {
    isMobile: o,
    isResponsive: e
  }, children: e && o ? /* @__PURE__ */ s.jsx(te, { open: n, onOpenChange: r, ...t }) : /* @__PURE__ */ s.jsx(fe, { open: n, onOpenChange: r, ...t }) });
};
xe.displayName = "Popover";
const Ce = (e) => {
  const {
    isMobile: t,
    isResponsive: o
  } = i.useContext(g);
  return o && t ? /* @__PURE__ */ s.jsx(ne, { ...e }) : /* @__PURE__ */ s.jsx(ve, { ...e });
};
Ce.displayName = "PopoverTrigger";
const he = i.forwardRef(({
  className: e,
  align: t = "center",
  sideOffset: o = 4,
  ...n
}, r) => {
  const {
    isMobile: a,
    isResponsive: c
  } = i.useContext(g);
  return c && a ? /* @__PURE__ */ s.jsx(oe, { ...n, className: A("!tw-w-screen !tw-max-w-[100vw]", e) }) : /* @__PURE__ */ s.jsx(Pe, { children: /* @__PURE__ */ s.jsx(me, { ref: r, align: t, sideOffset: o, className: A("tw-outline-none tw-z-max tw-rounded-8 tw-shadow-xl data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0 data-[state=closed]:tw-zoom-out-95 data-[state=open]:tw-zoom-in-95 data-[side=bottom]:tw-slide-in-from-top-2 data-[side=left]:tw-slide-in-from-right-2 data-[side=right]:tw-slide-in-from-left-2 data-[side=top]:tw-slide-in-from-bottom-2", e), ...n }) });
});
he.displayName = "PopoverContent";
const we = i.forwardRef(({
  ...e
}, t) => {
  const {
    isMobile: o,
    isResponsive: n
  } = i.useContext(g);
  return n && o ? /* @__PURE__ */ s.jsx(re, { ...e }) : /* @__PURE__ */ s.jsx($, { ref: t, ...e, "aria-label": "close" });
});
we.displayName = "PopoverClose";
const Re = ({
  ...e
}) => {
  const {
    isMobile: t,
    isResponsive: o
  } = i.useContext(g);
  return o && t ? null : /* @__PURE__ */ s.jsx(ge, { ...e });
};
Re.displayName = "PopoverArrow";
export {
  xe as P,
  Re as a,
  we as b,
  he as c,
  Ce as d
};
//# sourceMappingURL=Popover.IWkkIIzd.js.map
